import { useEffect } from "react";
import "./index.css";

function AdSenseResult() {
    useEffect(() => {
        try {
            if (window.adsbygoogle) {
                window.adsbygoogle.push({});
            }
        } catch (error) {
            console.error("AdSenseResult error", error);
        }
    }, []);

    return (
        <div className="adsense-result-wrapper my-4">
            <ins
                class="adsbygoogle"
                data-ad-client="ca-pub-1757046056951934"
                data-ad-format="fluid"
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-slot="1580193716"
                style={{ display: "block" }}
            />
        </div>
    );
}

export default AdSenseResult;
